// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-container {
  height: 100vh;
  width: 100vw;
  flex-basis: auto;
  flex-grow: 1;
  display: flex;
}`, "",{"version":3,"sources":["webpack://./src/_core/components/common/AppContainer.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;AACF","sourcesContent":[".app-container {\r\n  height: 100vh;\r\n  width: 100vw;\r\n  flex-basis: auto;\r\n  flex-grow: 1;\r\n  display: flex;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
